import { Currency } from "./currency.type";
import { IPricing, SalaryType } from "./salary.type";

export enum UserRole {
  Admin = "admin",
  Director = "director",
  Cashier = "cashier",
  WarehouseMgr = "warehouseMgr",
  SalesDept = "salesDept",
  Manager = "manager",
  Accountant = "accountant",
  Foreman = "foreman",
  InventoryMgr = "inventoryMgr",
}

export interface User {
  _id: string;
  username: string;
  name: string;
  password: string;
  role: UserRole;
  createdAt: string;
  minuteNorm: number;
  pricings: IPricing[];
  salaryType: SalaryType;
  salaryCurrency: Currency;
}
